import ReactDOM from 'react-dom'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from '../../helpers/createStyles'
// import IconClose from '../../icons/gallery-close-desktop.svg'
// import IconZoom from '../../icons/gallery-zoom.svg'
// import IconLeft from '../../icons/gallery-arrow-left-desktop.svg'
// import IconRight from '../../icons/gallery-arrow-right-desktop.svg'
import { theme } from '../../styles/theme'
import { lerp } from '../../helpers/math'
import cn from 'classnames'

// const CURSOR = {
//   CLOSE: <IconClose />,
//   ZOOM: <IconZoom />,
//   LEFT: <IconLeft />,
//   RIGHT: <IconRight />
// }

const Cursor = ({ type }) => {
  const styles = useStyles()

  return (
    <svg className={cn(styles.cursor, type === 'CLOSE' && styles.close, type === 'ZOOM' && styles.zoom)} width='52' height='33' viewBox='0 0 52 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <line className={cn(styles.lineShort, (type === 'LEFT' || type === 'RIGHT') && styles.lineLong)} x1='1' y1='16.5' x2='51' y2='16.5' stroke='currentColor' />
      <line className={cn(styles.vertLine, (type === 'LEFT' || type === 'RIGHT') && styles.vertLineInvisible)} x1='26.5' y1='33' x2='26.5' y2='2.18557e-08' stroke='currentColor' />
      <path className={cn(styles.arrow, type === 'LEFT' && styles.arrowVisible)} d='M15 31L1 16.5L17 0.5' stroke='currentColor' />
      <path className={cn(styles.arrow, type === 'RIGHT' && styles.arrowVisible)} d='M37 31L51 16.5L35 0.5' stroke='currentColor' />
    </svg>
  )
}

const GalleryCursor = ({ refs, open }) => {
  const styles = useStyles()
  const cursorRef = useRef()
  const [icon, setIcon] = useState('CLOSE')
  const target = useRef({ x: -100, y: -100 })
  const position = useRef({ x: -100, y: -100 })
  const running = useRef(false)

  const handleMouseMove = useCallback(
    event => {
      target.current.x = event.clientX
      target.current.y = event.clientY

      if (refs.activeImage?.contains(event.target)) {
        setIcon('ZOOM')
      } else if (refs.nextSlide?.contains(event.target)) {
        setIcon('RIGHT')
      } else if (refs.prevSlide?.contains(event.target)) {
        setIcon('LEFT')
      } else {
        setIcon('CLOSE')
      }
    },
    [refs]
  )

  useEffect(() => {
    const render = () => {
      if (running.current && cursorRef.current) {
        position.current.x = lerp(position.current.x, target.current.x, 0.3)
        position.current.y = lerp(position.current.y, target.current.y, 0.3)
        cursorRef.current.style.transform = `translate(${position.current.x - 26}px, ${position.current.y - 16}px)`
        window.requestAnimationFrame(render)
      }
    }

    if (open) {
      running.current = true
      window.addEventListener('mousemove', handleMouseMove, { passive: true })
      window.requestAnimationFrame(render)

      return () => {
        running.current = false
        window.removeEventListener('mousemove', handleMouseMove)
      }
    }
  }, [open])

  return ReactDOM.createPortal(
    <div className={styles.root} ref={cursorRef}>
      {/* {React.cloneElement(Cursor, { className: styles.image })} */}
      <Cursor className={styles.image} type={icon} />
    </div>,
    document.body
  )
}

const useStyles = createUseStyles({
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    pointerEvents: 'none',
    zIndex: theme.zIndex.cursor,
    mixBlendMode: 'difference'
  },
  cursor: {
    color: 'white !important',
    transform: 'scale(1)',
    transition: 'all 0.3s ease-out'
  },
  close: {
    transform: 'scale(1) rotate(45deg)'
  },
  zoom: {
    color: 'white !important'
  },
  arrow: {
    opacity: 0,
    transform: 'scale(0)',
    transformOrigin: '50% 50%',
    transition: 'all 0.3s ease-out'
  },
  arrowVisible: {
    opacity: '1 !important',
    transform: 'scale(1) !important'
  },
  vertLine: {
    opacity: 1,
    transform: 'scaleY(1)',
    transformOrigin: '50% 50%',
    transition: 'all 0.3s ease-out'
  },
  vertLineInvisible: {
    opacity: 0,
    transform: 'scaleY(0)'
  },
  lineShort: {
    transform: 'scaleX(0.66) translateX(0.8px)',
    transformOrigin: '50% 50%',
    transition: 'all 0.3s ease-out'
  },
  lineLong: {
    transform: 'scaleX(1) translateY(0px) !important'
  }
})

GalleryCursor.propTypes = {
  refs: PropTypes.object
}

export default GalleryCursor
